var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLongRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.5V11.5C2 11.3674 2.05268 11.2402 2.14645 11.1464C2.24021 11.0527 2.36739 11 2.5 11H18V9C18.0014 8.90213 18.0314 8.80682 18.0865 8.72589C18.1415 8.64495 18.2191 8.58195 18.3096 8.54468C18.4001 8.50742 18.4995 8.49753 18.5956 8.51625C18.6917 8.53497 18.7801 8.58147 18.85 8.65L21.85 11.65C21.9422 11.7451 21.9938 11.8725 21.9938 12.005C21.9938 12.1375 21.9422 12.2648 21.85 12.36L18.85 15.36C18.7795 15.4291 18.6901 15.4758 18.5931 15.4942C18.4962 15.5126 18.3959 15.5018 18.305 15.4633C18.2141 15.4248 18.1366 15.3603 18.0823 15.2778C18.0281 15.1954 17.9994 15.0987 18 15V13H2.5C2.36739 13 2.24021 12.9473 2.14645 12.8535C2.05268 12.7598 2 12.6326 2 12.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLongRight);
export default __webpack_public_path__ + "static/media/arrowLongRight.5f99e879263171e79af5b7bab9898ff1.svg";
export { ForwardRef as ReactComponent };